import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5c81ef66&scoped=true"
import script from "@/views/Dashboard/Dashboard.ts?vue&type=script&lang=ts&external"
export * from "@/views/Dashboard/Dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Dashboard/dashboard.scss?vue&type=style&index=0&id=5c81ef66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c81ef66",
  null
  
)

export default component.exports